import axios from "axios";
import BeePlugin from "bee-plugin";
import { debounce, isNull } from "lodash";
import moment from "moment";
import React, { Component, createContext } from "react";
import { Alert } from "rsuite";
import {
	deleteCampaign,
	deleteSmsCampaign,
	getEmailCampaigns,
	getSmsCampaigns,
	getSocialAds,
	getSocialCampaigns,
} from "./components/camagin";
import constants from "./constants";
import { getAuthHeader } from "./utils/get-token";
export const Context = createContext();

let iniState = {};

export class Provider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			role: "",
			userPlan: null,
			productData: [],
			apiCalledFlag: false,
			contact_upload_count: 0,
			profile_picture_url: "",
			savedTemplate: "",
			external_custom_rows: [],
			mergeTags: [],
			dataMigration: [
				{
					id: 1,
					name: "Products",
					status: "In Progress",
					migratedRecords: null,
				},
				{
					id: 2,
					name: "Orders",
					status: "In Progress",
					migratedRecords: null,
				},
				{
					id: 3,
					name: "Customers",
					status: "In Progress",
					migratedRecords: null,
				},
				{
					id: 4,
					name: "Collections",
					status: "In Progress",
					migratedRecords: null,
				},
			],
			campaignFormData: {
				senderName: "Ravi Shankar",
				email: "ravi.shankar@dataphion.com",
				subjectLine: "",
				replyToAddress: "ravi.shankar@dataphion.com",
			},
			metadata_attributes: {},
			templateName: "",
			templateImg: "",
			templatenames: "",
			enterprisename: "",
			selectedoption: "",
			wallet_data: {
				id: 0,
				total_balance: 0,
				free_facts: 0,
				paid_facts: 0,
				account_archived_days: 0,
				account_suspended_days: 0,
				account_deleted_days: 0,
				expires_on: 0,
				suspension_overusage_days: 0,
				expire_date: moment(),
				suspension_overusage_date: moment(),
				account_suspended_date: moment(),
				plan: { id: 0, Name: "", product: { id: 0, name: "" } },
				auto_topup_amount: 0,
				auto_topup: false,
				manual_topup: false,
				manual_topup_threshold: 0,
				auto_topup_threshold: 0,
				is_promotional: false,
				paying_customer: false,
				current_account_status: "",
				offline_customer: false,
			},
			user_data: {
				identifier: "",
				password: "",
				recpatchaValue: "",
			},
			notifications: [],
			campagincreation: {
				campaignname: null,
				campaigntype: null,
				campaign_id: -1,
				campaigndescription: null,
				// recipients
				recipientbox: null,
				dnd_contacts: false,
				chipData: [],
				audiencelist: null,
				sender_name: null,
				sender_email: null,
				email_subject_line: "",
				chosenEmoji: {},
				token: "select",
				defaultValue: "",
				design: null,
				reply_address: null,
				campaign_date: null,
				campaign_time: null,
				campaign_recur: null,
				multi_date: null,
				job_start_time: null,
				job_started_on: null,
				job_completed_on: null,
				days: [],
				recipient: {},
				campaign_data_id: undefined,
				campaign_job_id: undefined,
				// Custom added for fix defect FBM-684
				selected_list: null,
				audience_list: null,
				autosegment_list: null,
				default_email: true,
				custom_email: false,
				object_id: "",
				object_name: "",
				column_id: "",
				column_name: "",
				selected_custom_objects: [],
				indivisual_contact: null,
			},
			smscampaign: {
				smsname: "",
				description: "",
				sendername: "",
				campaign_id: -1,
				campaign_job_id: undefined,
				fact_campaign_id: -1,
				fact_campaign_job: -1,
				selected_list: [],
				custom_email: false,
				default_email: true,
				selected_custom_objects: [],
				audience_listnew: [],
				autosegments_list: [],
				indivisual_listnew: [],
				startdate: "",
				starttime: "",
				enddate: "",
				days: [],
				design: "",
				recur: "",
				created_on: null,
				recurring: null,
				start_time: null,
				end_time: null,
				sms_body: "",
				mainarray: {
					list: [],
					audience: [],
					contact: [],
				},
			},
			socialAdCreation: {
				campaign_id: -1,
				socialMediaName: "",
				socialPlatformName: [],
				adobeXdConference: "",
				job_started_on: null,
				job_completed_on: null,
				numberofClicks: 0,
				specific_spending: 0,
				total_spending: 0,
				campaign_recur: "",
				all_audience: [],
				selectedAudience: [],
				selected_include: {},
				selected_exclude: {},
				checkList: [
					{
						label: "Facebook",
						value: "facebook",
						checked: false,
						helperText:
							"1 million FB users who match the criteria you've defined but you don't know them personally",
					},
					{
						label: "Marketing Engine",
						value: "factoreal",
						checked: false,
						helperText:
							"0 Marketing Engine contacts will be targeted on Facebook.",
					},
				],
				headline: "",
				description: "",
				fbadd: "",
				fbchannel: "",
				cta: "select",
				cta_link: "",
				cta_link_desc: "",
				upload_urls: [],
			},
			socialAdAudience: {
				onlyIncludeSelectedValue: {
					"Custom Audience": {},
					"Lookalike Audience": {},
				},
				onlyExcludeSelectedValue: {
					"Custom Audience": {},
					"Lookalike Audience": {},
				},
			},
			selectedUserLocation: false,
			journeyTemplates: {
				campaign_name: "",
				goal: "",
				use_case: "",
				occasion: "",
				custom_events: "",
				email_layout: "",
				template: {},
				reminder_time: null,
				email_goal: "",
				operator: "",
				email_trigger: "",
				goal_url: "",
				resend_email: {
					checked: false,
					label: "You want to resend the email",
					value: "resend email",
					number_of_emails: 0,
					number_of_days: 0,
				},
				subject_line: [],
				days_for_add_contact: 0,
				contact_list: [],
				email_address: "",
				email_subject_line: [],
				personalize: "",
				reply_to_address: "",
				end_date: null,
				cart_operator: "",
				cart_value: null,
			},
			facebook_access_token: "",
			customertype: "",
			beefree_resolve: null,
			beefree_reject: null,
			beefree_args: null,
			beefree_popup: false,
			contact_upload: { preview_row: [], preview_cols: [] },
			listOutFbUserFilters: [],
			fbUserFiterInsightActionData: {},
			fbUserFiterInsightActionDataInEx: {},
			rootFiltersWithContact: "",
			fbCustomAction: "",
			folders_accessible: [],
			user_permissions: [],
			moderator_details: {},
			moderation_asset_type: "",
			current_user: {
				email: "",
				name: "",
				approval_details: {},
				is_approver: false,
			},
			folder_structure: {},
			is_folder_enabled: false,
			default_folder: "",
			key_mapping: {},
			is_context_ready: false,
			enterprise_approved: false,
			campaign_current_pages: {
				email: 1,
				sms: 1,
			},
			campaign_counts: {
				email: 0,
				sms: 0,
				social_post: 0,
				social_ad: 0,
			},
			campaign_dashboard_loader: false,
			campaigns: {
				active_tab: "2",
				filter: "7",
				date_name: "Last 7 days",
				date_sub_name: `${moment().add(-6, "days").format("Do MMM")} - ${moment().format("Do MMM")}`,
			},
			sms_campaigns: {
				data: [],
				cards: [],
				search: "",
				force_reload_data: true,
			},
			email_campaigns: {
				data: [],
				cards: [],
				search: "",
				force_reload_data: true,
			},
			social_posts: {
				data: [],
				cards: [],
				search: "",
				force_reload_data: true,
			},
			social_ads: {
				data: [],
				cards: [],
				search: "",
				force_reload_data: true,
			},
			active_template_tab: "1",
			showLandingPages: true,
			enterprise_account_type: "Stripe",
			bot_provider: "",
		};
		this.debounceCampaignSearch = debounce(this.debounceCampaignSearch, 2000);

		iniState = this.state;
	}

	componentDidMount = async () => {
		try {
			if (window.localStorage.getItem("user_token")) {
				this.getRandomProducts();
			} else {
				console.log("No user!");
			}
			if (Number(window.localStorage.getItem("enterprise_id"))) {
				await Promise.allSettled([
					this.getenterprise(),
					this.getModeratorInfo(),
					this.getUserRolesInfo(),
				]);
			} else {
				console.log("No enterprise");
			}
			const existingScript = document.getElementById("satisfiScript");
			if (
				!existingScript &&
				Number(window.localStorage.getItem("enterprise_id")) > 0 &&
				constants.all_domains.includes(window.location.hostname)
			) {
				const script = document.createElement("script");
				script.src = "https://chat.satis.fi/popup/embedder?popupId=18836";
				script.id = "satisfiScript";
				document.body.appendChild(script);
			}
			// const whatfixScript = document.getElementById("whatfix");
			// const whatfixScriptTag =
			// 	window.location.hostname !== constants.all_domains[1]
			// 		? constants.whatfix_url[0]
			// 		: constants.whatfix_url[1];
			// if (!whatfixScript) {
			// 	const w_script = document.createElement("script");
			// 	w_script.src = whatfixScriptTag;
			// 	w_script.language = "javascript";
			// 	w_script.async = "true";
			// 	w_script.type = "text/javascript";
			// 	w_script.id = "whatfix";
			// 	w_script.crossorigin = "";
			// 	document.body.appendChild(w_script);
			// }
			this.setState({ is_context_ready: true });
		} catch (error) {
			console.error(error);
		}
	};

	forceCampaignApiCall = () => {
		const campaigns = this.state.campaigns;
		if (campaigns.active_tab === "2") {
			const email_campaigns = this.state.email_campaigns;
			email_campaigns.force_reload_data = true;
			this.setState({ email_campaigns });
		} else if (campaigns.active_tab === "4") {
			const social_posts = this.state.social_posts;
			social_posts.force_reload_data = true;
			this.setState({ social_posts });
		} else if (campaigns.active_tab === "5") {
			const social_ads = this.state.social_ads;
			social_ads.force_reload_data = true;
			this.setState({ social_ads });
		} else if (campaigns.active_tab === "6") {
			const sms_campaigns = this.state.sms_campaigns;
			sms_campaigns.force_reload_data = true;
			this.setState({ sms_campaigns });
		}
	};

	deleteCampaign = async (data, channel) => {
		let response = "";
		const campaign_counts = this.state.campaign_counts;
		if (channel === "sms") {
			response = await deleteSmsCampaign(data);
		} else {
			response = await deleteCampaign(data);
		}
		if (response) {
			if (channel === "email") {
				const email_campaigns = this.state.email_campaigns;
				email_campaigns.data = email_campaigns.data.filter(
					(campaign) => String(campaign.id) !== String(data.id),
				);
				campaign_counts[channel] = campaign_counts[channel] - 1;
				this.setState({ email_campaigns, campaign_counts });
			} else if (channel === "sms") {
				const sms_campaigns = this.state.sms_campaigns;
				sms_campaigns.data = sms_campaigns.data.filter(
					(campaign) => String(campaign.id) !== String(data.id),
				);
				campaign_counts[channel] = campaign_counts[channel] - 1;
				this.setState({ sms_campaigns, campaign_counts });
			} else if (channel === "social_post") {
				const social_posts = this.state.social_posts;
				social_posts.data = social_posts.data.filter(
					(campaign) => String(campaign.id) !== String(data.id),
				);
				campaign_counts[channel] = campaign_counts[channel] - 1;
				this.setState({ social_posts, campaign_counts });
			} else if (channel === "social_ad") {
				const social_ads = this.state.social_ads;
				social_ads.data = social_ads.data.filter(
					(campaign) => String(campaign.id) !== String(data.id),
				);
				campaign_counts[channel] = campaign_counts[channel] - 1;
				this.setState({ social_ads, campaign_counts });
			}
		}
	};

	handleDateFilter = (e) => {
		const days = [7, 15, 30];
		const campaigns = this.state.campaigns;
		const { campaign_current_pages } = this.state;
		campaigns.date_sub_name = "";
		campaigns.date_name = e.item.props.children;
		if (Number(e.key) !== 3) {
			campaigns.filter = `${days[e.key]}`;
			campaigns.date_sub_name = `${moment()
				.add(-(days[e.key] - 1), "days")
				.format("Do MMM")} - ${moment().format("Do MMM")}`;
		} else {
			campaigns.filter = "all";
		}
		const sms_campaigns = this.state.sms_campaigns;
		const email_campaigns = this.state.email_campaigns;
		const social_posts = this.state.social_posts;
		const social_ads = this.state.social_ads;

		sms_campaigns.force_reload_data = true;
		email_campaigns.force_reload_data = true;
		social_posts.force_reload_data = true;
		social_ads.force_reload_data = true;

		campaign_current_pages.email = 1;
		campaign_current_pages.sms = 1;

		this.setState(
			{
				campaigns,
				sms_campaigns,
				email_campaigns,
				social_posts,
				social_ads,
				campaign_current_pages,
			},
			() => {
				this.getCampaignsData();
				this.getCampaignsCount();
			},
		);
	};

	handleCampaignPageChange = (page, campaign_type) => {
		const { campaign_current_pages, email_campaigns, sms_campaigns } =
			this.state;
		if (campaign_type === "email") {
			campaign_current_pages.email = page;
			email_campaigns.force_reload_data = true;
			this.setState({ campaign_current_pages, email_campaigns }, () => {
				this.getCampaignsData();
			});
		} else if (campaign_type === "sms") {
			campaign_current_pages.sms = page;
			sms_campaigns.force_reload_data = true;
			this.setState({ campaign_current_pages, sms_campaigns }, () => {
				this.getCampaignsData();
			});
		}
	};

	handleAdvancedFilters = (campaign) => {
		const sms_campaigns = this.state.sms_campaigns;
		const email_campaigns = this.state.email_campaigns;
		const social_posts = this.state.social_posts;
		const social_ads = this.state.social_ads;
		const { campaign_current_pages } = this.state;

		if (campaign === "email_campaigns") {
			email_campaigns.force_reload_data = true;
			campaign_current_pages.email = 1;
		} else if (campaign === "sms_campaigns") {
			sms_campaigns.force_reload_data = true;
			campaign_current_pages.sms = 1;
		} else if (campaign === "social_posts") {
			social_posts.force_reload_data = true;
		} else if (campaign === "social_ads") {
			social_ads.force_reload_data = true;
		}

		this.setState(
			{
				sms_campaigns,
				email_campaigns,
				social_posts,
				social_ads,
				campaign_current_pages,
			},
			() => {
				this.getCampaignsData();
				this.getCampaignsCount();
			},
		);
	};

	debounceCampaignSearch = () => {
		this.getCampaignsData();
		this.getCampaignsCount();
	};

	handleCampaignSearch = (search, channel) => {
		const { campaign_current_pages } = this.state;
		if (channel === "email") {
			const email_campaigns = this.state.email_campaigns;
			email_campaigns.search = search;
			email_campaigns.force_reload_data = true;
			campaign_current_pages.email = 1;
			this.setState({ email_campaigns, campaign_current_pages });
			this.debounceCampaignSearch();
		} else if (channel === "sms") {
			const sms_campaigns = this.state.sms_campaigns;
			sms_campaigns.search = search;
			sms_campaigns.force_reload_data = true;
			campaign_current_pages.sms = 1;
			this.setState({ sms_campaigns, campaign_current_pages });
			this.debounceCampaignSearch();
		} else if (channel === "social_post") {
			const social_posts = this.state.social_posts;
			social_posts.search = search;
			social_posts.force_reload_data = true;
			this.setState({ social_posts });
			this.debounceCampaignSearch();
		} else if (channel === "social_ad") {
			const social_ads = this.state.social_ads;
			social_ads.search = search;
			social_ads.force_reload_data = true;
			this.setState({ social_ads });
			this.debounceCampaignSearch();
		}
	};

	handleCampaignTabChange = (tab) => {
		const campaigns = this.state.campaigns;
		campaigns.active_tab = tab;
		this.setState({ campaigns }, () => {
			this.getCampaignsData();
		});
	};

	handleTemplateManagerTabChange = (tab) => {
		this.setState({ active_template_tab: tab });
	};

	showLandingPage = (showPage) => {
		this.setState({ showLandingPages: showPage });
	};

	reloadCampaignsData = async (number = null) => {
		const campaigns = this.state.campaigns;
		if (number) {
			campaigns.active_tab = number;
		}
		if (campaigns.active_tab === "2") {
			const email_campaigns = this.state.email_campaigns;
			email_campaigns.force_reload_data = true;
			this.setState({ email_campaigns }, () => {
				this.getCampaignsData();
				this.getCampaignsCount();
			});
		} else if (campaigns.active_tab === "4") {
			const social_posts = this.state.social_posts;
			social_posts.force_reload_data = true;
			this.setState({ social_posts }, () => {
				this.getCampaignsData();
				this.getCampaignsCount();
			});
		} else if (campaigns.active_tab === "5") {
			const social_ads = this.state.social_ads;
			social_ads.force_reload_data = true;
			this.setState({ social_ads }, () => {
				this.getCampaignsData();
				this.getCampaignsCount();
			});
		} else if (campaigns.active_tab === "6") {
			const sms_campaigns = this.state.sms_campaigns;
			sms_campaigns.force_reload_data = true;
			this.setState({ sms_campaigns }, () => {
				this.getCampaignsData();
				this.getCampaignsCount();
			});
		}
	};

	getCampaignsData = async () => {
		this.setState({ campaign_dashboard_loader: true });
		const campaigns = this.state.campaigns;
		let allAdvancedfilters = JSON.parse(
			localStorage.getItem("advanced_filters"),
		);
		allAdvancedfilters = allAdvancedfilters ? allAdvancedfilters : null;
		if (
			this.state.email_campaigns.force_reload_data &&
			campaigns.active_tab === "2"
		) {
			// get email campaigns
			const email_campaigns = this.state.email_campaigns;
			const body = {
				filter: campaigns.filter,
				search: email_campaigns.search,
				page: this.state.campaign_current_pages.email,
				folders_accessible: this.state.folders_accessible,
			};
			if (allAdvancedfilters?.email_campaigns) {
				body.advanced_filters = allAdvancedfilters.email_campaigns;
			}
			const emailCampaigns = await getEmailCampaigns(body);
			email_campaigns.data = emailCampaigns.row;
			email_campaigns.cards = emailCampaigns.cards;
			email_campaigns.force_reload_data = false;
			this.setState({ email_campaigns });
		} else if (
			this.state.social_posts.force_reload_data &&
			campaigns.active_tab === "4"
		) {
			// get social posts
			const social_posts = this.state.social_posts;
			const body = {
				filter: campaigns.filter,
				search: social_posts.search,
			};
			if (allAdvancedfilters?.social_posts) {
				body.advanced_filters = allAdvancedfilters.social_posts;
			}
			const socialCampaigns = await getSocialCampaigns(body);
			social_posts.data = socialCampaigns;
			social_posts.force_reload_data = false;
			this.setState({ social_posts });
		} else if (
			this.state.social_ads.force_reload_data &&
			campaigns.active_tab === "5"
		) {
			// get social ads
			const social_ads = this.state.social_ads;
			const body = {
				filter: campaigns.filter,
				search: social_ads.search,
			};
			if (allAdvancedfilters?.social_ads) {
				body.advanced_filters = allAdvancedfilters.social_ads;
			}
			const socialAdsData = await getSocialAds(body);
			social_ads.data = socialAdsData.row;
			social_ads.cards = socialAdsData.cards;
			social_ads.force_reload_data = false;
			this.setState({ social_ads });
		} else if (
			this.state.sms_campaigns.force_reload_data &&
			campaigns.active_tab === "6"
		) {
			// get sms campaigns
			const sms_campaigns = this.state.sms_campaigns;
			const body = {
				filter: campaigns.filter,
				search: sms_campaigns.search,
				page: this.state.campaign_current_pages.sms,
			};
			if (allAdvancedfilters?.sms_campaigns) {
				body.advanced_filters = allAdvancedfilters.sms_campaigns;
			}
			const smsCampaigns = await getSmsCampaigns(body);
			sms_campaigns.data = smsCampaigns.row;
			sms_campaigns.cards = smsCampaigns.cards;
			sms_campaigns.force_reload_data = false;
			this.setState({ sms_campaigns });
		}
		this.setState({ campaign_dashboard_loader: false });
	};

	getCampaignsCount = async () => {
		const campaigns = this.state.campaigns;
		let allAdvancedfilters = JSON.parse(
			localStorage.getItem("advanced_filters"),
		);
		const req = {
			method: "POST",
			url: constants.CAMPAIGNS_COUNT_URL,
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: {
				filter_type: campaigns.filter,
				search: this.state.email_campaigns.search,
				folders_accessible: this.state.folders_accessible,
			},
		};
		if (allAdvancedfilters?.email_campaigns) {
			req["data"]["email_advanced_filters"] =
				allAdvancedfilters.email_campaigns;
		}
		if (allAdvancedfilters?.sms_campaigns) {
			req["data"]["sms_advanced_filters"] = allAdvancedfilters.sms_campaigns;
		}
		const response = await axios(req);
		if (response.status === 200) {
			this.setState({
				campaign_counts: {
					email: response.data.email,
					sms: response.data.sms,
					social_post: response.data.social_posts,
					social_ad: response.data.social_ads,
				},
			});
		}
	};

	getenterprise = () => {
		fetch(constants.enterprise_details, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				...getAuthHeader(),
			},
		})
			.then((response) => response.json())
			.then(({ data }) => {
				if (!data) return;
				window.localStorage.setItem("customer_type", data.customertype);
				window.localStorage.setItem("channel_type", data.channeltype);
				this.setState({ customertype: data.customertype });
				if (data.customertype !== "premium") {
					this.getWalletInfo();
				}
				window.localStorage.setItem(
					"factcube_enabled",
					data.factcube_enabled !== undefined ? data.factcube_enabled : false,
				);
				window.localStorage.setItem(
					"dash_currency",
					data.currency !== null ? data.currency : "$",
				);
				this.setState({
					enterprise_account_type: data.enterprise_account_type
						? data.enterprise_account_type
						: "Stripe",
				});
			})
			.catch((err) => {
				console.log("Error in getenterprise", err);
			});

		// Check if conversation bot is enabled
		fetch(constants.claims, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				...getAuthHeader(),
			},
		})
			.then((response) => response.json())
			.then((response) => {
				const botClaims = [];
				const FMMClaims = [];
				response.data?.map((element) => {
					if (element.feature === "Conversation Bot") botClaims.push(element);
					else if (element.feature === "FAN_MATURITY_MODEL")
						FMMClaims.push(element);
				});
				if (botClaims.length === 0) {
					window.localStorage.setItem("bot_enabled", "true");
				} else {
					if (botClaims[0].disabled === true) {
						window.localStorage.setItem("bot_enabled", "false");
					} else {
						window.localStorage.setItem("bot_enabled", "true");
					}
				}
				if (FMMClaims.length === 0) {
					console.log("Inside length 0");
					window.localStorage.setItem("FMM_enabled", "true");
				} else {
					if (FMMClaims[0].disabled === true) {
						window.localStorage.setItem("FMM_enabled", "false");
					} else {
						window.localStorage.setItem("FMM_enabled", "true");
					}
				}
			});
	};
	setFbToken = (e) => {
		this.setState({ facebook_access_token: e });
	};

	setMetadata = (val) => {
		console.log("INCOMING VAL METADATA:", val);
		this.setState({ metadata_attributes: val });
	};

	setDefaultFolder = (val) => {
		this.setState({ default_folder: val });
	};

	clearCampaignData = () => {
		this.setState({
			campagincreation: {
				campaignname: null,
				campaigntype: null,
				campaigndescription: null,
				// recipients
				recipientbox: null,
				chipData: [],
				audiencelist: null,
				sender_name: null,
				sender_email: null,
				email_subject_line: "",
				chosenEmoji: {},
				token: "select",
				defaultValue: "",
				design: null,
				reply_address: null,
				campaign_date: null,
				campaign_time: null,
				campaign_recur: null,
				multi_date: null,
				job_start_time: "",
				job_started_on: "",
				job_completed_on: "",
				days: [],
				recipient: {},
				campaign_data_id: undefined,
				campaign_job_id: undefined,
				// Custom added for fix defect FBM-684
				selected_list: null,
				audience_list: null,
				autosegment_list: null,
				default_email: true,
				custom_email: false,
				object_id: "",
				object_name: "",
				column_id: "",
				column_name: "",
				selected_custom_objects: [],
				indivisual_contact: null,
			},
		});
	};
	clearsmsdata = () => {
		this.setState({
			smscampaign: {
				smsname: "",
				description: "",
				recur: "",
				sendername: "",
				campaign_id: -1,
				campaign_job_id: undefined,
				fact_campaign_id: -1,
				fact_campaign_job: -1,
				selected_list: [],
				audience_listnew: [],
				autosegments_list: [],
				indivisual_listnew: [],
				custom_email: false,
				default_email: true,
				selected_custom_objects: [],
				startdate: "",
				starttime: "",
				enddate: "",
				days: [],
				created_on: null,
				recurring: null,
				start_time: null,
				end_time: null,
				design: "",
				mainarray: {
					list: [],
					audience: [],
					contact: [],
				},
			},
		});
	};

	clearSocialAdData = () => {
		console.log("????clearSocialAdData");
		this.setState({
			socialAdCreation: {
				selectedUserLocation: false,
				campaign_id: -1,
				socialMediaName: "",
				socialPlatformName: [],
				adobeXdConference: "",
				job_started_on: null,
				job_completed_on: null,
				numberofClicks: 0,
				specific_spending: 0,
				total_spending: 0,
				campaign_recur: "",
				all_audience: [],
				selectedAudience: [],
				selected_include: {},
				selected_exclude: {},
				checkList: [
					{
						label: "Facebook",
						value: "facebook",
						checked: false,
						helperText:
							"1 million FB users who match the criteria you've defined but you don't know them personally",
					},
					{
						label: "Factoreal",
						value: "factoreal",
						checked: false,
						helperText: "0 factoreal contacts will be targeted on Facebook.",
					},
				],
				headline: "",
				description: "",
				fbadd: "",
				fbchannel: "",
				cta: "select",
				cta_link: "",
				cta_link_desc: "",
				upload_urls: [],
			},
			socialAdAudience: {
				onlyIncludeSelectedValue: {
					"Custom Audience": {},
					"Lookalike Audience": {},
				},
				onlyExcludeSelectedValue: {
					"Custom Audience": {},
					"Lookalike Audience": {},
				},
			},
		});
	};

	clearjourneyTemplates = () => {
		this.setState({
			journeyTemplates: {
				campaign_name: "",
				goal: "",
				use_case: "",
				occasion: "",
				custom_events: "",
				email_layout: "",
				template: {},
				reminder_time: null,
				email_goal: "",
				operator: "",
				email_trigger: "",
				goal_url: "",
				resend_email: {
					checked: false,
					label: "You want to resend the email",
					value: "resend email",
					number_of_emails: 0,
					number_of_days: 0,
				},
				subject_line: [],
				days_for_add_contact: 0,
				contact_list: [],
				email_address: "",
				email_subject_line: [],
				personalize: "",
				reply_to_address: "",
				end_date: null,
				cart_operator: "",
				cart_value: null,
			},
		});
	};

	campagincreation = async (e, type) => {
		if (type === "campaign_name") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaignname: e,
				},
			});
		} else if (type === "campaign_type") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, campaigntype: e },
			});
		} else if (type === "category") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, category: e },
			});
		} else if (type === "campaign_id") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, campaign_id: e },
			});
		} else if (type === "campaign_desc") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaigndescription: e,
				},
			});
		} else if (type === "dnd_contacts") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, dnd_contacts: e },
			});
		} else if (type === "") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, recipientbox: e },
			});
		} else if (type === "select-list") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, chipData: e },
			});
		} else if (type === "audience-list") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, audiencelist: e },
			});
		} else if (type === "sender_name") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					sender_name: e,
				},
			});
		} else if (type === "sender_email") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, sender_email: e },
			});
		} else if (type === "auto-populate") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, sender_name: e },
			});
		} else if (type === "email_subject_line") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					[type]: e,
				},
			});
		} else if (type === "email_subject_recommendations") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					email_subject_recommendations: e,
				},
			});
		} else if (type === "chosenEmoji") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					chosenEmoji: e,
				},
			});
		} else if (type === "token") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					token: e,
				},
			});
		} else if (type === "defaultValue") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					defaultValue: e,
				},
			});
		} else if (type === "reply-address") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					reply_address: e.target.value,
				},
			});
		} else if (type === "design-box") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, design: e },
			});
		} else if (type === "job_start_time") {
			this.setState({
				campagincreation: { ...this.state.campagincreation, job_start_time: e },
			});
		} else if (type === "job_completed_on") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					job_completed_on: e,
				},
			});
		} else if (type === "campaign_recur") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaign_recur: e,
				},
			});
		} else if (type === "job_started_on") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					job_started_on: e,
				},
			});
		} else if (type === "days") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					days: e,
				},
			});
		} else if (type === "campaign_data_id") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaign_data_id: e,
				},
			});
		} else if (type === "campaign_job_id") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaign_job_id: e,
				},
			});
		} else if (type === "recipient") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					recipient: e,
				},
			});
			// Custom added for fix defect FBM-684
		} else if (type === "selected_list") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					selected_list: e,
				},
			});
		} else if (type === "audience_list") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					audience_list: e,
				},
			});
		} else if (type === "autosegment_list") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					autosegment_list: e,
				},
			});
		} else if (type === "indivisual_contact") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					indivisual_contact: e,
				},
			});
		} else if (type === "default_email") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					default_email: e,
				},
			});
		} else if (type === "custom_email") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					custom_email: e,
				},
			});
		} else if (type === "object_id") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					object_id: e,
				},
			});
		} else if (type === "object_name") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					object_name: e,
				},
			});
		} else if (type === "column_id") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					column_id: e,
				},
			});
		} else if (type === "column_name") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					column_name: e,
				},
			});
		} else if (type === "selected_custom_objects") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					selected_custom_objects: e,
				},
			});
		}
	};
	smscampaign = (e, type) => {
		if (type === "smsname") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					smsname: e,
				},
			});
		} else if (type === "sendername") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					sendername: e,
				},
			});
		} else if (type === "campaign_id") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					campaign_id: e,
				},
			});
		} else if (type === "description") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					description: e,
				},
			});
		} else if (type === "selected_list") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					selected_list: e,
				},
			});
		} else if (type === "audience_listnew") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					audience_listnew: e,
				},
			});
		} else if (type === "autosegments_new") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					autosegments_new: e,
				},
			});
		} else if (type === "custom_email") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					custom_email: e,
				},
			});
		} else if (type === "default_email") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					default_email: e,
				},
			});
		} else if (type === "selected_custom_objects") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					selected_custom_objects: e,
				},
			});
		} else if (type === "indivisual_listnew") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					indivisual_listnew: e,
				},
			});
		} else if (type === "mainarray") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					mainarray: e,
				},
			});
		} else if (type === "design") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					design: e,
				},
			});
		} else if (type === "fact_campaign_id") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					fact_campaign_id: e,
				},
			});
		} else if (type === "fact_campaign_job") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					fact_campaign_job: e,
				},
			});
		} else if (type === "recur") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					recur: e,
					startdate: "",
					starttime: "",
					enddate: "",
					days: [],
				},
			});
		} else if (type === "startdate") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					startdate: e,
				},
			});
		} else if (type === "starttime") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					starttime: e,
				},
			});
		} else if (type === "enddate") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					enddate: e,
				},
			});
		} else if (type === "days") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					days: e,
				},
			});
		} else if (type === "recurring") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					recurring: e,
				},
			});
		} else if (type === "start_time") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					start_time: e,
				},
			});
		} else if (type === "created_on") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					created_on: e,
				},
			});
		} else if (type === "end_time") {
			this.setState({
				smscampaign: {
					...this.state.smscampaign,
					end_time: e,
				},
			});
		} else if (type === "campaign_job_id") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaign_job_id: e,
				},
			});
		}
	};

	storeSocialAdLoc = (e, type) => {
		if (type === "userlocation") {
			this.setState({
				selectedUserLocation: e,
			});
		}
	};

	setSocialAdAudience = (data, type) => {
		const { onlyIncludeSelectedValue, onlyExcludeSelectedValue } =
			this.state.socialAdAudience;
		if (type === "SET") {
			this.setState({
				socialAdAudience: data,
			});
			return;
		}
		if (type === "include") {
			this.setState({
				socialAdAudience: {
					onlyExcludeSelectedValue: onlyExcludeSelectedValue,
					onlyIncludeSelectedValue: data,
				},
			});
		} else {
			this.setState({
				socialAdAudience: {
					onlyIncludeSelectedValue: onlyIncludeSelectedValue,
					onlyExcludeSelectedValue: data,
				},
			});
		}
	};

	socialAdCreation = (e, type) => {
		if (type === "socialMediaName") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					socialMediaName: e,
				},
			});
		} else if (type === "campaign_id") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					campaign_id: e,
				},
			});
		} else if (type === "socialPlatformName") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					socialPlatformName: e,
				},
			});
		} else if (type === "adobeXdConference") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					adobeXdConference: e,
				},
			});
		} else if (type === "job_started_on") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					job_started_on: e,
					specific_spending: 0,
					total_spending: 0,
				},
			});
		} else if (type === "job_completed_on") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					job_completed_on: e,
					specific_spending: 0,
					total_spending: 0,
				},
			});
		} else if (type === "numberofClicks") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					numberofClicks: e,
				},
			});
		} else if (type === "specific_spending") {
			const d1 = moment(this.state.socialAdCreation.job_completed_on);
			const d2 = moment(this.state.socialAdCreation.job_started_on);
			const totalint = moment.duration(d1.diff(d2)).asDays();
			const total = Math.round(totalint);
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					specific_spending: e,
					total_spending: e * total,
				},
			});
		} else if (type === "total_spending") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					total_spending: e,
				},
			});
		} else if (type === "campaign_recur") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					campaign_recur: e,
				},
			});
		} else if (type === "all_audience") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					all_audience: e,
				},
			});
		} else if (type === "selectedAudience") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					selectedAudience: e,
				},
			});
		} else if (type === "include") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					selected_include: e,
				},
			});
		} else if (type === "exclude") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					selected_exclude: e,
				},
			});
		} else if (type === "checkList") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					checkList: e,
				},
			});
		} else if (type === "headline") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					headline: e,
				},
			});
		} else if (type === "description") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					description: e,
				},
			});
		} else if (type === "fbadd") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					fbadd: e,
				},
			});
		} else if (type === "fbchannel") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					fbchannel: e,
				},
			});
		} else if (type === "cta") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					cta: e,
				},
			});
		} else if (type === "cta_link") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					cta_link: e,
				},
			});
		} else if (type === "cta_link_desc") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					cta_link_desc: e,
				},
			});
		} else if (type === "upload_urls") {
			this.setState({
				socialAdCreation: {
					...this.state.socialAdCreation,
					upload_urls: e,
				},
			});
		} else {
			return null;
		}
	};

	journeyTemplates = (e, type) => {
		console.log("update journeyTemplates", { [type]: e });
		if (type === "campaign_name") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					campaign_name: e,
				},
			});
		} else if (type === "goal") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					goal: e,
				},
			});
		} else if (type === "use_case") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					use_case: e,
					occasion: "",
				},
			});
		} else if (type === "occasion") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					occasion: e,
				},
			});
		} else if (type === "custom_events") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					custom_events: e,
				},
			});
		} else if (type === "email_layout") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					email_layout: e,
				},
			});
		} else if (type === "template") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					template: e,
				},
			});
		} else if (type === "reminder_time") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					reminder_time: e,
				},
			});
		} else if (type === "email_goal") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					email_goal: e,
				},
			});
		} else if (type === "operator") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					operator: e,
				},
			});
		} else if (type === "email_trigger") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					email_trigger: e,
				},
			});
		} else if (type === "goal_url") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					goal_url: e,
				},
			});
		} else if (type === "resend_email") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					resend_email: e,
				},
			});
		} else if (type === "email_subject_line") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					[type]: e,
				},
			});
		} else if (type === "days_for_add_contact") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					days_for_add_contact: e,
				},
			});
		} else if (type === "contact_list") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					contact_list: e,
				},
			});
		} else if (type === "email_address") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					email_address: e,
				},
			});
		} else if (type === "subject_line") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					subject_line: e,
				},
			});
		} else if (type === "personalize") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					personalize: e,
				},
			});
		} else if (type === "reply_to_address") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					reply_to_address: e,
				},
			});
		} else if (type === "end_date") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					end_date: e,
				},
			});
		} else if (type === "cart_operator") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					cart_operator: e,
				},
			});
		} else if (type === "cart_value") {
			this.setState({
				journeyTemplates: {
					...this.state.journeyTemplates,
					cart_value: e,
				},
			});
		}
	};

	getWalletInfo = async () => {
		try {
			const enterpriseID = window.localStorage.getItem("enterprise_id");

			const query = `{
                                walletinfos(where: { enterprise: { id: ${enterpriseID} } }) {
                                    id
                                    free_fact
                                    paid_facts
                                    auto_topup_amount
                                    auto_topup
                                    manual_topup
                                    manual_topup_threshold
                                    auto_topup_threshold
                                    is_promotional
                                    paying_customer
                                    subscription_start_date
                                    account_archived_date
                                    account_suspended_date
                                    account_deleted_date
                                    expires_on
                                    suspension_overusage_date
                                    current_account_status
                                    offline_customer
                                    plan {
                                        id
                                        Name
                                        standard_price
                                        product {
                                            id
                                            name
                                        }
                                    }
                                    enterprise {
                                        id
                                        org_name
                                        customertype
                                    }
                                }
                            }`;
			const payload = {
				url: constants.graphql,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...getAuthHeader(),
				},
				data: JSON.stringify({ query }),
			};
			const response = await axios(payload);
			if ([200, 201].includes(response.status)) {
				const walletinfos = response.data.data.walletinfos[0];
				const total_balance = walletinfos.free_fact + walletinfos.paid_facts;

				this.setState({
					wallet_data: {
						...this.state.wallet_data,
						id: Number(walletinfos.id),
						total_balance: total_balance,
						paid_facts: walletinfos.paid_facts,
						free_facts: walletinfos.free_fact,
						account_archived_days: await this.calculateDateDifference(
							walletinfos.account_archived_date,
						),
						account_suspended_days: await this.calculateDateDifference(
							walletinfos.account_suspended_date,
						),
						account_deleted_days: await this.calculateDateDifference(
							walletinfos.account_deleted_date,
						),
						expires_on: await this.calculateDateDifference(
							walletinfos.expires_on,
						),
						suspension_overusage_days: await this.calculateDateDifference(
							walletinfos.suspension_overusage_date,
						),
						expire_date: walletinfos.expires_on,
						subscription_start_date: walletinfos.subscription_start_date,
						suspension_overusage_date: walletinfos.suspension_overusage_date,
						account_suspended_date: walletinfos.account_suspended_date,
						plan: walletinfos.plan ? walletinfos.plan : {},
						auto_topup_amount: walletinfos.auto_topup_amount,
						auto_topup: walletinfos.auto_topup,
						manual_topup: walletinfos.manual_topup,
						manual_topup_threshold: walletinfos.manual_topup_threshold,
						auto_topup_threshold: walletinfos.auto_topup_threshold,
						is_promotional: walletinfos.is_promotional,
						paying_customer: walletinfos.paying_customer,
						current_account_status: walletinfos.current_account_status,
						offline_customer: walletinfos.offline_customer,
					},
				});
			}
			return "done";
		} catch (error) {
			console.log(error);
		}
	};

	resetGlobalContext = async () => {
		const campaign_counts = {
			email: 0,
			sms: 0,
			social_post: 0,
			social_ad: 0,
		};
		const campaigns = {
			active_tab: "2",
			filter: "7",
			date_name: "Last 7 days",
			date_sub_name: `${moment().add(-6, "days").format("Do MMM")} - ${moment().format("Do MMM")}`,
		};
		const sms_campaigns = {
			data: [],
			cards: [],
			search: "",
			force_reload_data: true,
		};
		const email_campaigns = {
			data: [],
			cards: [],
			search: "",
			force_reload_data: true,
		};
		const social_posts = {
			data: [],
			cards: [],
			search: "",
			force_reload_data: true,
		};
		const social_ads = {
			data: [],
			cards: [],
			search: "",
			force_reload_data: true,
		};
		console.log("Inside resetGlobalContext");

		this.setState({
			folders_accessible: [],
			user_permissions: [],
			moderator_details: {},
			moderation_asset_type: "",
			current_user: {
				email: "",
				name: "",
				approval_details: {},
				is_approver: false,
			},
			folder_structure: {},
			is_folder_enabled: false,
			default_folder: "",
			key_mapping: {},
			enterprise_approved: false,
			campaign_counts,
			campaigns,
			sms_campaigns,
			email_campaigns,
			social_posts,
			social_ads,
		});

		console.log("Global context has been reset");
	};

	//get moderator details
	getModeratorInfo = async () => {
		console.log("Start of getModeratorInfo");
		const fields = ["id", "is_active", "json", "asset_type"];
		const payload = {
			url: `${constants.moderationdetails}/enterprise/${window.localStorage.getItem("enterprise_id")}`,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: JSON.stringify({ fields }),
		};

		console.log("Before API call of getModeratorInfo");
		const response = await axios(payload);
		if ([200, 201].includes(response.status)) {
			if (
				response.data?.data?.length &&
				response.data.data[0].is_active &&
				response.data.data[0].json
			) {
				console.log("Going to set state moderator_details");
				console.log(JSON.stringify(response.data.data[0].json));

				this.setState({
					moderator_details: response.data.data[0].json,
					moderation_asset_type: response.data.data[0].asset_type,
				});
			}
		}
	};

	//get UserRoles details
	getUserRolesInfo = async () => {
		console.time("getUserRolesInfo");
		const query = `{
            user(id:${Number(window.localStorage.getItem("id"))}) {
                id,
                email,
                firstname,
                lastname,
                factorealroles {
                    id,
                    folders,
                    permissions
                },
                rolecategory{
                    id,
                    name
                },
                enterprise {
                    enterprise_approved
                    addon_country
                    bot_provider
					double_optin_enabled
                }
            },
            folderstructuredetails(where:{enterprise:{id:${window.localStorage.getItem("enterprise_id")}}}){
                folderstructure,
                keymapping
            }
        }`;

		const payload = {
			url: constants.graphql,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: JSON.stringify({ query }),
		};
		let response;
		for (let attempt = 1; attempt <= 3; attempt++) {
			try {
				console.log(`Attempt ${attempt}: Before API call of getUserRolesInfo`);
				response = await axios(payload);

				this.setState({
					role: response.data.data.user?.rolecategory?.name,
					bot_provider:
						response.data.data?.user?.enterprise?.bot_provider || "",
					double_optin_enabled:
						response.data.data?.user?.enterprise?.double_optin_enabled ?? false,
				});

				if ([200, 201].includes(response.status) && response.data.data) {
					if (response.data.data.user) {
						if (response.data.data.user.stage) {
							window.localStorage.setItem(
								"user_stage",
								response.data.data.user.stage,
							);
						}
						if (response.data.data.user.enterprise.addon_country) {
							window.localStorage.setItem(
								"enterprise_country",
								response.data.data.user.enterprise.addon_country,
							);
						}
						console.log("Going to generateUserRoles");
						this.generateUserRoles(response.data.data.user);
					}

					if (
						response.data.data?.folderstructuredetails &&
						response.data.data.folderstructuredetails.length > 0 &&
						response.data.data.folderstructuredetails[0].folderstructure
					) {
						const folder_structure =
							response.data.data.folderstructuredetails[0].folderstructure;
						const key_mapping =
							response.data.data.folderstructuredetails[0].keymapping;
						key_mapping.global = "Global";

						const is_folder_enabled =
							folder_structure.children && folder_structure.children.length > 0;

						this.setState({ folder_structure, is_folder_enabled, key_mapping });
					}
					break;
				}

				// delay 1 second
				if (attempt < 3) {
					await new Promise((resolve) => setTimeout(resolve, 1000));
				}
			} catch (error) {
				// delay 1 second
				if (attempt < 3) {
					await new Promise((resolve) => setTimeout(resolve, 1000));
				}
			}
		}
		console.timeEnd("getUserRolesInfo");
	};

	generateUserRoles = (user) => {
		console.time("generateUserRoles");
		let folders_accessible = [];
		let user_permissions = [];
		const moderator_details = this.state.moderator_details;
		const current_user = {
			email: user.email,
			name:
				(user.firstname ? `${user.firstname} ` : "") +
				(user.lastname ? user.lastname : ""),
			approval_details: {},
			is_approver: false,
		};

		if (user.enterprise) {
			this.setState({
				enterprise_approved: user.enterprise.enterprise_approved,
			});
		}

		//get folders_accessbile and permissions
		if (user.factorealroles && user.factorealroles.length > 0) {
			for (const role of user.factorealroles) {
				folders_accessible = folders_accessible.concat(role.folders);
				user_permissions = user_permissions.concat(role.permissions);
			}
		}

		folders_accessible = [...new Set(folders_accessible)];
		user_permissions = [...new Set(user_permissions)];

		let default_folder = window.localStorage.getItem("default_folder");

		if (
			!default_folder ||
			!(default_folder.trim().length > 0) ||
			!folders_accessible.includes(default_folder)
		) {
			folders_accessible.sort((a, b) => {
				if (a.split("/").length < b.split("/").length) {
					return -1;
				}
				if (a.split("/").length < b.split("/").length) {
					return 1;
				}
				if (a < b) {
					return -1;
				}
				if (a > b) {
					return 1;
				}
				return 0;
			});

			default_folder = folders_accessible[0];
		}

		folders_accessible.push("global");

		if (moderator_details.approvers && moderator_details.approvers.length > 0) {
			for (const approver of moderator_details.approvers) {
				const approver_level_users = approver.users;
				const approvers_found = approver_level_users.filter(
					(item) => item.email.toLowerCase() === user.email.toLowerCase(),
				);
				if (approvers_found.length > 0) {
					const user_approver_details = {
						level: approver.level,
						is_super_approver:
							approver.highest_level &&
							moderator_details.last_approver_override,
					};
					current_user.is_approver = true;
					current_user.approval_details = user_approver_details;
					break;
				}
			}
		}

		this.setState({
			folders_accessible,
			user_permissions,
			current_user,
			default_folder,
		});
		console.timeEnd("generateUserRoles");
	};

	calculateDateDifference = async (date) => {
		const today = new Date();
		const today_year = today.getFullYear();
		const today_month = today.getMonth();
		const today_day = today.getDate();
		const today_moment = moment([today_year, today_month, today_day]);
		const future_date = new Date(date);
		const future_date_year = future_date.getFullYear();
		const future_date_month = future_date.getMonth();
		const future_date_day = future_date.getDate();
		const future_date_moment = moment([
			future_date_year,
			future_date_month,
			future_date_day,
		]);
		const diff = future_date_moment.diff(today_moment, "days");
		return date ? diff : 0;
	};

	getTotalBalance = (e) => {
		this.setState({ total_balance: e });
	};

	cleaerTotalBalance = () => {
		this.setState({ total_balance: 0 });
	};

	populateCampaignData = (response) => {
		const date_format = moment().format();
		let job_start_time = moment(moment().add(5, "minutes"), "HH:mm:ss");
		let job_completed_on = moment(moment(), "YYYY-MM-DD");
		let job_started_on = moment(moment(), "YYYY-MM-DD");
		let campaign_recur = "";
		let campaign_data_id = undefined;
		let campaign_job_id = undefined;
		let chipsetData = [];
		const chip_data = [];
		let days = [];
		if (response.list_id) {
			chipsetData = response.list_id.split(",");

			for (const id of chipsetData) {
				chip_data.push(Number.parseInt(id));
			}
			chipsetData.push(Number.parseInt(response.list_id));
		}
		if (response.campaignjob) {
			//days populate
			if (response.campaignjob.days) {
				days = response.campaignjob.days.split(",");
			}
			//start time populate
			if (response.campaignjob.job_start_time) {
				const e = moment(response.campaignjob.job_start_time).format();
				job_start_time = moment(e);
			}
			//start date populate
			if (response.campaignjob.job_started_on) {
				job_started_on = moment(
					response.campaignjob.job_started_on,
					"YYYY-MM-DD",
				);
			}
			//completed date populate
			if (response.campaignjob.job_completed_on) {
				job_completed_on = moment(
					response.campaignjob.job_completed_on,
					"YYYY-MM-DD",
				);
			}
			if (response.campaignjob.campaign_recur) {
				campaign_recur = response.campaignjob.campaign_recur;
			}
		}
		if (response.campaignjob) {
			if (response.campaignjob.id) {
				campaign_job_id = response.campaignjob.id;
			}
		}

		if (response.factorealcampaigndatum) {
			if (response.factorealcampaigndatum.id) {
				campaign_data_id = response.factorealcampaigndatum.id;
			}
		}
		this.setState({
			campagincreation: {
				...this.state.campagincreation,
				campaignname: response.name,
				campaigntype: response.campaigntype,
				campaigndescription: response.description ? response.description : "",
				recipientbox: response.destination_type,
				chipData: chip_data,
				audiencelist: response.list_id,
				sender_name: response.sender_name,
				sender_email: response.sender_email,
				email_subject_line: response.subject,
				reply_address: response.reply_to,
				design: response.content_creation_method,
				campaign_date: date_format,
				job_start_time: job_start_time,
				job_started_on: job_started_on,
				job_completed_on: job_completed_on,
				days: days,
				campaign_recur: campaign_recur,
				campaign_data_id: campaign_data_id,
				campaign_job_id: campaign_job_id,
				recipient: response.recipient,
			},
		});
	};

	callToFectchContactColumnData = async function () {
		const contact_list = {
			method: "POST",
			url: constants.graphql,
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: JSON.stringify({
				query:
					"{contactscolumndata{id,column_name,column_type,merge_tag,default_value}}",
			}),
		};

		const contactList = await axios(contact_list);

		if ([200, 201].includes(contactList.status)) {
			const mergeTags = this.state.mergeTags;
			if (contactList.data.data.contactscolumndata) {
				for (const contact of contactList.data.data.contactscolumndata) {
					if (
						!isNull(contact.merge_tag) &&
						contact.tag !== "paying_customer" &&
						contact.tag !== "ltv" &&
						contact.tag !== "factoreal_contact_source"
					) {
						mergeTags.push({
							name: contact.default_value
								? `${contact.merge_tag} (${contact.default_value})`
								: contact.merge_tag,
							value: `[${contact.merge_tag}]`,
						});
					}
				}
				this.setState({ mergeTags });
			}
		} else {
			Alert.error(
				"* Error in processing your request. Please contact me-support@satisfilabs.com.",
			);
			console.log(
				"Error in processing your request. Please contact me-support@satisfilabs.com.",
			);
			this.props.parent.history.push("/campaign");
		}
	}.bind(this);

	autoSaveTemplate = (jsonFile) => {
		if (window.location.pathname.split("/")[1] === "create-template") {
			axios
				.put(
					`${constants.usertemplates}/${window.location.pathname.split("/")[3]}`,
					{ template_json: JSON.parse(jsonFile) },
					{
						headers: {
							"Content-Type": "application/json",
							...getAuthHeader(),
						},
					},
				)
				.catch((err) => {
					Alert.error(
						"Error in processing your request. Please contact me-support@satisfilabs.com.",
					);
				});
		} else if (
			window.location.pathname.split("/")[1] === "edit-template" ||
			window.location.pathname.split("/")[1] === "create-templates"
		) {
		} else if (window.location.pathname.split("/")[4] !== "edit-template") {
			this.setState({
				campagincreation: {
					...this.state.campagincreation,
					campaign_data_id:
						window.location.pathname.split("/")[4] === "drag-and-drop"
							? window.location.pathname.split("/")[5]
							: window.location.pathname.split("/")[5] === "template-editor"
								? window.location.pathname.split("/")[6]
								: "",
				},
			});
			const body = {
				json_data: JSON.parse(jsonFile),
				factorealcampaign: Number.parseInt(
					window.location.pathname.split("/")[2],
				),
				check: true,
				campaign_type: "email",
			};

			axios
				.put(
					`${constants.factorealcampaigndata}/${
						window.location.pathname.split("/")[4] === "drag-and-drop"
							? window.location.pathname.split("/")[5]
							: window.location.pathname.split("/")[5] === "template-editor"
								? window.location.pathname.split("/")[6]
								: ""
					}`,
					body,
					{
						headers: {
							"Content-Type": "application/json",
							...getAuthHeader(),
						},
					},
				)
				.catch((err) => {
					Alert.error("Error in Api cal345l");
				});
		}
	};

	/**
	 * @param this Is a reference to the *this* global object of UnlayerEditor class
	 * @description This method has been designed to handle the saving of email template designs
	 */
	exportHtmlForSave = (that) => {
		that.emailEditorRef.current.editor.exportHtml((data) => {
			const { design, html } = data;
			if (design && html) {
				that.setState(
					{
						templateJson: design,
						templateHtml: html,
					},
					() =>
						this.save(that.state.templateJson, that.state.templateHtml, that),
				);
			}
		});
	};

	/**
	 * @param that Is a reference to the *this* global object of the UnlayerEditor class
	 * @description This method has been designed to check if the template name chosen already exists or not.
	 */
	templateNameExist = async (name) => {
		if (!name) {
			return false;
		}
		const check_template_exist = {
			method: "POST",
			url: constants.graphql,
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: JSON.stringify({
				query: `query{
                    enterprisetemplates(where:{name:"${name}"}){
                    id
                  }
              }`,
			}),
		};

		const template_exist = await axios(check_template_exist);

		if ([200, 201].includes(template_exist.status)) {
			if (template_exist.data.data.enterprisetemplates.length > 0) {
				return true;
			}
			if (template_exist.data.data.enterprisetemplates.length === 0) {
				return false;
			}
		}
	};
	/**
	 * @param that Is a reference to the *this* global object of the UnlayerEditor class
	 * @description This method has been designed handle the selected image from the Image Library
	 */
	selectFromLibrary = (that) => {
		that.setState({ library_modal: true });
		const bucketBody = {
			url: constants.get_accessible_images,
			method: "post",
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: {
				folders_accessible: this.state.folders_accessible,
			},
		};
		axios(bucketBody)
			.then((response) => {
				const data = response.data;
				that.setState({ library_data: data });
			})
			.catch((error) => console.log(error));
	};

	/**
	 * @param e This is the event object generated when the file (Image) upload event is triggered
	 * @param that Is a reference to *this* global object of UnlayerEditor class
	 * @description This method is designed to trigger the file (Image) upload to AWS S3 bucket
	 */
	handleUploadedFiles = (e, that, folder) => {
		that.setState({ loading: true });
		const fileWithNewName = new File([e.file], Date.now() + e.file.name);

		const data = {
			folder: folder,
			size: fileWithNewName.size,
			type: fileWithNewName.type,
		};

		const form_data = new FormData();
		form_data.append("files.file", fileWithNewName);
		form_data.append("data", JSON.stringify(data));

		const uploadAWS = {
			method: "post",
			url: constants.media_upload,
			headers: getAuthHeader(),
			data: form_data,
		};
		axios(uploadAWS).then((response) => {
			that.done({
				url: response.data.data.meta["public-url"],
			});
			that.setState({ imageSelectionVisible: false, loading: false });
		});
	};

	/**
	 * @param that is a reference to *this* global object of UnlayerEditor class
	 * @description This method has been defined to fetch the list of industries
	 */
	fetch_list_industryList = async (that) => {
		const fetch_list_industry = {
			method: "POST",
			url: constants.graphql,
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
			data: JSON.stringify({
				query: `query{
          industrytemplates{
            id
            industry_name,
          }
        }`,
			}),
		};
		const industry = await axios(fetch_list_industry);
		if ([200, 201].includes(industry.status)) {
			const industryList = [];
			for (const industry_data of industry.data.data.industrytemplates) {
				industryList.push({
					value: industry_data.id,
					text: industry_data.industry_name,
				});
			}
			that.setState({ industryList: industryList });
		}
	};

	/**
	 * @param that is a reference to this global object of UnlayerEditor class
	 * @description Exports html and json design templates
	 */
	exportHtmlForSaveAsTemplate = (that, selectedFolder) => {
		that.emailEditorRef.current.editor.exportHtml((data) => {
			const { design, html } = data;
			if (design && html) {
				that.setState(
					{
						templateJson: design,
						templateHtml: html,
					},
					() =>
						this.saveAsTemplate(
							that,
							selectedFolder,
							that.state.templateJson,
							that.state.templateHtml,
						),
				);
			}
		});
	};

	variantTestingSaveAsTemplate = (that, selectedFolder) => {
		if (that.state.htmlData && that.state.jsonData) {
			that.setState(
				{
					templateJson: that.state.jsonData,
					templateHtml: that.state.htmlData,
				},
				() =>
					this.saveAsTemplate(
						that,
						selectedFolder,
						that.state.templateJson,
						that.state.templateHtml,
					),
			);
		}
	};

	/**
	 * @param file holds the file (Image) to be uploaded
	 * @description This function has been written to upload image file to server.
	 */
	uploadFiles = async (file) => {
		const form_data = new FormData();
		form_data.append("files", file);

		try {
			const uploadData = {
				method: "post",
				url: constants.upload,
				headers: getAuthHeader(),
				data: form_data,
			};
			const uplaodedImage = await axios(uploadData);
			return uplaodedImage;
		} catch (error) {
			console.log(error);
		}
	};

	/**
	 * @param jsonFile This parameters holds the json format of the templates created.
	 * @param html_data This parameters holds the html format of the templates created.
	 * @description This is an asynchronous function, created for *react-email-editor* to save the templates for reuse.
	 */
	saveAsTemplate = async function (that, folder, jsonFile, html_data) {
		const { display_condition } = that.state;
		const folderpath = folder ? folder : "root";
		if (window.location.pathname.split("/")[5] === "template-editor") {
			const body = {
				json: jsonFile,
				html: html_data,
				enterprise: window.localStorage.getItem("enterprise_id"),
				industrytemplate: 1,
				factorealcampaigns: [
					Number.parseInt(window.location.pathname.split("/")[2]),
				],
				name: this.state.templatenames,
				folder: folderpath,
				display_condition_json: display_condition,
			};
			axios
				.post(constants.enterprisetemplates, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then((response) => {
					that.setState(
						{ loading: false, template_created: response.data },
						() => {
							Alert.success(
								"Template saved successfully.",
								constants.alertDuration,
							);
						},
					);
				})
				.catch((err) => {
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
							constants.alertDuration,
						);
						console.log(err);
					});
				});
		} else {
			const body = {
				json: jsonFile,
				html: html_data,
				enterprise: window.localStorage.getItem("enterprise_id"),
				industrytemplate: 1,
				name: this.state.templatenames,
				folder: folderpath,
				display_condition_json: display_condition,
				metadata_attributes: that.state.metadata_details,
			};
			axios
				.post(constants.enterprisetemplates, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then((response) => {
					that.setState(
						{ loading: false, template_created: response.data },
						() => {
							Alert.success(
								"Template saved successfully.",
								constants.alertDuration,
							);
							if (window.location.href.includes("createtemplate")) {
								that.props.history.push({
									pathname: `/edit-template/${response.data.id}`,
									state: { name: response.data.name },
								});
							}
						},
					);
				})
				.catch((err) => {
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
							constants.alertDuration,
						);
						console.log(err);
					});
				});
		}
	}.bind(this);
	/**
	 * @description The method has been designed to fetch a set of random products from the shop.
	 */
	getRandomProducts = async () => {
		const productsArrayAll = [];
		let randomProducts = {};
		try {
			randomProducts = await axios.get(constants.getRandomProductsUrl, {
				headers: {
					"Content-Type": "application/json",
					...getAuthHeader(),
				},
			});
			if (
				Array.isArray(randomProducts?.data?.cart?.items) &&
				randomProducts?.data?.cart?.items?.length
			) {
				for (const product of randomProducts.data.cart.items) {
					productsArrayAll.push({
						name: product.name,
						price: product.variants[0].price,
						image: product.variants[0].imageUrl,
						quantity: product.quantity,
						variantTitle: product.variants[0].title,
						variantOption1: product.variants[0].option1,
						variantOption2: product.variants[0].option2,
						variantOption3: product.variants[0].option3,
						currency: product.variants[0].currency,
					});
				}
				this.setState({
					productData: productsArrayAll,
					apiCalledFlag: true,
				});
			} else {
				this.setState({
					productData: productsArrayAll,
					apiCalledFlag: true,
				});
			}
		} catch (error) {
			console.error(error);
			this.setState({
				productData: productsArrayAll,
				apiCalledFlag: true,
			});
		}
	};
	/**
	 * @param jsonFile This parameters holds the json format of the templates created.
	 * @param htmlFile This parameters holds the html format of the templates created.
	 * @param that This parameters holds the reference to *this* keyword from the calling function.
	 * @description This is an asynchronous function, created for react-email-editor to send the templates as an email instead of saving it for reuse.
	 */
	save = async function (jsonFile, htmlFile, that) {
		const { display_condition } = that.state;
		const pathnames = window.location.pathname.split("/");
		if (
			pathnames[3] === "create-new" &&
			pathnames[4] === "start-from-scratch"
		) {
			const body = {
				html_data: htmlFile,
				json_data: jsonFile,
				enterprise: window.localStorage.getItem("enterprise_id"),
				display_condition_json: display_condition,
			};

			axios
				.post(constants.journeytemplates, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then((response) => {
					that.setState({ loading: false }, () => {
						window.localStorage.setItem("temp_id", response.data.id);
						window.close();
					});
				})
				.catch((err) => {
					console.log(" <== The error ==> \n", err);
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
						);
						console.log(err);
					});
				});
		} else if (pathnames[4] === "edit-template") {
			const body = {
				html_data: htmlFile,
				json_data: jsonFile,
				enterprise: window.localStorage.getItem("enterprise_id"),
				display_condition_json: display_condition,
				status: "draft",
			};
			const url = constants.journeytemplates;
			axios
				.post(url, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then((resp) => {
					that.setState({ loading: false }, () => {
						window.localStorage.setItem("temp_id", resp.data.id);
						that.props.history.push({
							pathname: "/templates",
						});
					});
				})
				.catch((err) => {
					console.log(" <== The error ==> \n", err);
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
						);
					});
				});
		} else if (pathnames[1] === "create-template") {
			//call update api on user table and move to campagin page
			const body = {
				html: htmlFile,
				template_json: jsonFile,
				display_condition_json: display_condition,
			};

			axios
				.put(`${constants.usertemplates}/${pathnames[3]}`, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then(() => {
					that.setState({ loading: false }, () => {
						Alert.success(
							"Template Save Successfully.",
							constants.alertDuration,
						);
						that.props.history.push({
							pathname: "/campaign",
						});
					});
				})
				.catch((err) => {
					console.log(" <== The error ==> \n", err);
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
							constants.alertDuration,
						);
					});
				});
		}
		//call for save data in factorealcampaigndata table
		else if (
			pathnames[1] === "campaign" &&
			pathnames[3] === "start" &&
			pathnames[4] === "drag-and-drop"
		) {
			this.setState({
				savedTemplate: { jsonFile: JSON.stringify(jsonFile), htmlFile },
			});
			const body = {
				json_data: jsonFile,
				factorealcampaign: Number.parseInt(pathnames[2]),
				check: true,
				campaign_type: "email",
				html_data: htmlFile,
				display_condition_json: display_condition,
			};

			const factorealcampaigndataid =
				pathnames[4] === "drag-and-drop"
					? pathnames[5]
					: pathnames[5] === "template-editor"
						? pathnames[6]
						: "";
			axios
				.put(
					`${constants.factorealcampaigndata}/${factorealcampaigndataid}`,
					body,
					{
						headers: {
							"Content-Type": "application/json",
							...getAuthHeader(),
						},
					},
				)
				.then(() => {
					that.setState({ loading: false }, () => {
						Alert.success(
							"Template Save Successfully.",
							constants.alertDuration,
						);
						that.props.history.push({
							pathname: `/newemailc/${pathnames[2]}/compose/${factorealcampaigndataid}`,
						});
					});
				})
				.catch((err) => {
					console.log(" <== The error ==> \n", err);
					that.setState({ loading: false }, () => {
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
						);
					});
				});
		} else if (pathnames[1] === "campaign") {
			this.setState({
				savedTemplate: { jsonFile: JSON.stringify(jsonFile), htmlFile },
			});
			if (pathnames[5] === "template-editor") {
				const body = {
					json_data: jsonFile,
					factorealcampaign: Number.parseInt(pathnames[2]),
					check: true,
					campaign_type: "email",
					html_data: htmlFile,
					display_condition_json: display_condition,
				};

				const factorealcampaigndataid =
					pathnames[5] === "template-editor" ? pathnames[6] : "";
				axios
					.put(
						`${constants.factorealcampaigndata}/${factorealcampaigndataid}`,
						body,
						{
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						},
					)
					.then(() => {
						that.setState({ loading: false }, () => {
							Alert.success("Template Save Successfully.");
							that.props.history.push({
								pathname: `/newemailc/${pathnames[2]}/compose/${factorealcampaigndataid}`,
							});
						});
					})
					.catch((err) => {
						console.log(" <== The error ==> \n", err);
						that.setState({ loading: false }, () => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
						});
					});
			} else {
				that.props.history.push({
					pathname: `/newemailc/${pathnames[2]}/compose/`,
				});
			}
		} else if (pathnames[1] === "edit-template") {
			const body = {
				json: jsonFile,
				html: htmlFile,
				display_condition_json: display_condition,
				status: "draft",
				asset_type: "email_template",
				metadata_attributes: that.state.metadata_details,
				name: that.state.template_name,
			};
			let url = "";
			if (that.state.is_submit_approval) {
				url = `${constants.submitForApproveTemplate}/${pathnames[2]}`;
			} else {
				url = `${constants.enterprisetemplates}/${pathnames[2]}`;
			}
			axios
				.put(url, body, {
					headers: {
						"Content-Type": "application/json",
						...getAuthHeader(),
					},
				})
				.then(() => {
					that.setState({ loading: false }, () => {
						if (url === `${constants.enterprisetemplates}/${pathnames[2]}`) {
							Alert.success("Saved Template");
						} else {
							Alert.success("Submitted for approval");
						}
						that.props.history.push({
							pathname: "/templates",
							state: { active_tab: "enterpriseTemplate" },
						});
						window.localStorage.setItem("temp_created", true);
						window.close();
					});
				})
				.catch((err) => {
					console.log(" <== The error ==> \n", err);
					that.setState({ loading: false }, () => {
						console.error(err);
						Alert.error(
							"Error in processing your request. Please contact me-support@satisfilabs.com.",
						);
					});
				});
		}
	}.bind(this);

	saveBeeFreeRow = (resolve, reject, arg) => {
		this.setState({
			beefree_reject: reject,
			beefree_resolve: resolve,
			beefree_args: arg,
			beefree_popup: true,
		});
	};
	hideBeeFreeRow = () => {
		this.setState({
			beefree_popup: false,
		});
	};

	updateCustomRows = async () => {
		const payload = {
			url: constants.footers_api,
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				...getAuthHeader(),
			},
		};
		const resp = await axios(payload);
		const p = [];
		for (const row of resp.data) {
			p.push({
				name: row.row_name,
				value: `${constants.footers_api}/${row.id}`,
			});
		}
		this.setState({ external_custom_rows: p });
	};

	callBeeFree = (template, that) => {
		let CLIENT_ID;
		let CLIENT_SECRET;
		if (
			window.location.href.split("/").includes("d38ujozxngp8ds.cloudfront.net")
		) {
			CLIENT_ID = "0cc2afe7-195a-4a1b-b09b-82d987f8e772";
			CLIENT_SECRET = "gilpJx9lv7eKVJVvE9y2lTnxpHvinNKTWVjNmMFuSf0Ifl9PeKON";
		} else if (
			window.location.href.split("/").includes("jaguars.factoreal.com")
		) {
			CLIENT_ID = "db2a7a70-43c1-4d18-92fe-9d1c7e09ed1f";
			CLIENT_SECRET = "mB6UAQehrHMTdMYKXE5gCqjpU0KklKEAAthbmU0pWah6ja8ukaWB";
		} else {
			CLIENT_ID = "b1200e3d-1d32-4319-9f1d-657383cecae4";
			CLIENT_SECRET = "FDnO0s8tFdvnPKkq7Myftv1MjVVFNR4Q1cdb65RCigVFagIiCnhy";
		}
		const CLIENT_UID = window
			.btoa(window.localStorage.getItem("user_token"))
			.replace(/=/g, "-"); // Beefree doesn't support = or any special character..
		const url_component = window.location.href.split("/");
		const domain = `${url_component[0]}//${url_component[2]}`;
		const DEFAULT_CONFIGURATION = {
			uid: CLIENT_UID,
			container: "bee-plugin-container",
			language: "en-US",
			autosave: true,
			onAutoSave: (jsonFile) => {
				if (
					window.location.pathname.split("/")[3] !== "create-new" &&
					window.location.pathname.split("/")[4] !== "start-from-scratch"
				) {
					this.autoSaveTemplate(jsonFile);
				}
			},
			specialLinks: [
				{
					type: "Frequently used",
					label: "Unsubscribe",
					link: "http://localhost:1337/ftreal/unsubscribe",
				},
			],
			mergeTags: this.state.mergeTags,
			mergeContents: this.state.custom_rows,
			rowsConfiguration: {
				emptyRows: true,
				defaultRows: true,
				externalContentURLs: [
					{
						name: "Footers",
						value: `${domain}/customrow/${window.localStorage.getItem("enterprise_id")}`,
					},
				],
			},
			contentDialog: {
				saveRow: {
					handler: (resolve, reject, args) => {
						this.saveBeeFreeRow(resolve, reject, args);
					},
				},
			},
		};
		const beeConfig = {
			language: "en-US",
			autosave: true,
			onSave: (jsonFile, htmlFile) => {
				if (
					window.location.pathname.split("/")[3] === "create-new" &&
					window.location.pathname.split("/")[4] === "start-from-scratch"
				) {
					const body = {
						html_data: htmlFile,
						json_data: JSON.parse(jsonFile),
						enterprise: window.localStorage.getItem("enterprise_id"),
					};

					axios
						.post(constants.journeytemplates, body, {
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						})
						.then((response) => {
							window.localStorage.setItem("temp_id", response.data.id);
							window.close();
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
							console.log(err);
						});
				} else if (window.location.pathname.split("/")[4] === "edit-template") {
					const body = {
						html_data: htmlFile,
						json_data: JSON.parse(jsonFile),
						enterprise: window.localStorage.getItem("enterprise_id"),
						status: "draft",
					};
					axios
						.post(constants.journeytemplates, body, {
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						})
						.then((resp) => {
							window.localStorage.setItem("temp_id", resp.data.id);
							window.close();
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
						});
				} else if (
					window.location.pathname.split("/")[1] === "create-template"
				) {
					//call update api on user table and move to campagin page
					const body = {
						html: htmlFile,
						template_json: JSON.parse(jsonFile),
					};

					axios
						.put(
							`${constants.usertemplates}/${window.location.pathname.split("/")[3]}`,
							body,
							{
								headers: {
									"Content-Type": "application/json",
									...getAuthHeader(),
								},
							},
						)
						.then((data) => {
							Alert.success("Template Save Successfully.");
							that.props.history.push({
								pathname: "/campaign",
							});
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
						});
				}
				//call for save data in factorealcampaigndata table
				else if (
					window.location.pathname.split("/")[1] === "campaign" &&
					window.location.pathname.split("/")[3] === "start" &&
					window.location.pathname.split("/")[4] === "drag-and-drop"
				) {
					this.setState({ savedTemplate: { jsonFile, htmlFile } });
					const body = {
						json_data: JSON.parse(jsonFile),
						factorealcampaign: Number.parseInt(
							window.location.pathname.split("/")[2],
						),
						check: true,
						campaign_type: "email",
						html_data: htmlFile,
					};

					axios
						.put(
							`${constants.factorealcampaigndata}/${
								window.location.pathname.split("/")[4] === "drag-and-drop"
									? window.location.pathname.split("/")[5]
									: window.location.pathname.split("/")[5] === "template-editor"
										? window.location.pathname.split("/")[6]
										: ""
							}`,
							body,
							{
								headers: {
									"Content-Type": "application/json",
									...getAuthHeader(),
								},
							},
						)
						.then((data) => {
							Alert.success("Template Save Successfully.");
							that.props.history.push({
								pathname: `/newemailc/${window.location.pathname.split("/")[2]}/compose/`,
							});
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
						});
				} else if (window.location.pathname.split("/")[1] === "campaign") {
					this.setState({ savedTemplate: { jsonFile, htmlFile } });
					if (window.location.pathname.split("/")[5] === "template-editor") {
						const body = {
							json_data: JSON.parse(jsonFile),
							factorealcampaign: Number.parseInt(
								window.location.pathname.split("/")[2],
							),
							check: true,
							campaign_type: "email",
							html_data: htmlFile,
						};

						axios
							.put(
								`${constants.factorealcampaigndata}/${
									window.location.pathname.split("/")[5] === "template-editor"
										? window.location.pathname.split("/")[6]
										: ""
								}`,
								body,
								{
									headers: {
										"Content-Type": "application/json",
										...getAuthHeader(),
									},
								},
							)
							.then((data) => {
								Alert.success("Template Save Successfully.");
								that.props.history.push({
									pathname: `/newemailc/${window.location.pathname.split("/")[2]}/compose/`,
								});
							})
							.catch((err) => {
								Alert.error(
									"Error in processing your request. Please contact me-support@satisfilabs.com.",
								);
							});
					} else {
						that.props.history.push({
							pathname: `/newemailc/${window.location.pathname.split("/")[2]}/compose/`, //${window.location.pathname.split("/")[5]},
						});
					}
				} else if (window.location.pathname.split("/")[1] === "edit-template") {
					const body = {
						json: JSON.parse(jsonFile),
						html: htmlFile,
						status: "draft",
						metadata_attributes: that.state.metadata_details,
					};
					axios
						.put(
							`${constants.enterprisetemplates}/${window.location.pathname.split("/")[2]}`,
							body,
							{
								headers: {
									"Content-Type": "application/json",
									...getAuthHeader(),
								},
							},
						)
						.then(() => {
							window.localStorage.setItem("temp_created", true);
							window.close();
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
						});
				}
			},
			onSaveAsTemplate: async function (jsonFile) {
				if (window.location.pathname.split("/")[5] === "template-editor") {
					const body = {
						json: JSON.parse(jsonFile),
						enterprise: window.localStorage.getItem("enterprise_id"),
						industrytemplate: 1,
						factorealcampaigns: [
							Number.parseInt(window.location.pathname.split("/")[2]),
						],
						name: this.state.templatenames,
					};
					axios
						.post(constants.enterprisetemplates, body, {
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
							console.log(err);
						});
				} else if (
					window.location.pathname.split("/")[1] === "create-templates"
				) {
					const body = {
						json: JSON.parse(jsonFile),
						enterprise: window.localStorage.getItem("enterprise_id"),
						industrytemplate: 1,
						name: this.state.templatenames,
						metadata_attributes: that.state.metadata_details,
					};
					axios
						.post(constants.enterprisetemplates, body, {
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						})
						.then((response) => {
							window.localStorage.setItem("temp_created", true);
							window.close();
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
							console.log(err);
						});
				} else {
					const body = {
						json: JSON.parse(jsonFile),
						enterprise: window.localStorage.getItem("enterprise_id"),
						industrytemplate: 1,
						name: this.state.templatenames,
					};
					axios
						.post(constants.enterprisetemplates, body, {
							headers: {
								"Content-Type": "application/json",
								...getAuthHeader(),
							},
						})
						.catch((err) => {
							Alert.error(
								"Error in processing your request. Please contact me-support@satisfilabs.com.",
							);
							console.log(err);
						});
				}
			}.bind(this),
		};
		const beeFinalConfig = {
			...DEFAULT_CONFIGURATION,
			...beeConfig,
		};

		const req = new XMLHttpRequest();
		req.onreadystatechange = () => {
			if (req.readyState === 4 && req.status === 200) {
				// Obtain token
				const token = req.responseText;
				// Call create method and pass token and beeConfig to obtain an instance of
				BeePlugin.create(token, beeConfig, (beePluginInstance) => {
					// Call start method of bee plugin instance
					beePluginInstance.start(template); // template is the json to be loaded in BEE
				});
			}
		};
		req.open(
			"POST", // Method
			"/token", // The server side endpoint that calls BEE REST auth endpoint
			false, // sync request
		);

		const beeEditor = new BeePlugin();
		beeEditor.getToken(CLIENT_ID, CLIENT_SECRET).then(() => {
			beeEditor.start(beeFinalConfig, template).then((response) => {
				that.setState({ beeFreeCallback: response });
			});
		});
	};

	senderEmailAndFun = (response) => {
		this.setState({
			campagincreation: {
				...this.state.campagincreation,
				sender_name: response.sender_name,
				sender_email: response.sender_email,
				reply_address: response.reply_to,
			},
		});
	};
	manageCampaignData = (type, value) => {
		const campaignFormData = this.state.campaignFormData;
		if (type === "senderName") {
			campaignFormData.senderName = value;
		} else if (type === "email") {
			campaignFormData.email = value;
		} else if (type === "subjectLine") {
			campaignFormData.subjectLine = value;
		} else if (type === "replyToAddress") {
			campaignFormData.replyToAddress = value;
		}
		this.setState({ campaignFormData });
	};

	templateNameChange = (type, value) => {
		this.setState({ templateName: value });
	};
	templatenamesave = (value) => {
		this.setState({ templatenames: value });
	};
	enterprisenamesave = (value) => {
		this.setState({ enterprisename: value });
	};
	selectedoptionsave = (value) => {
		this.setState({ selectedoption: value });
	};

	createTemplateImg = (templateImg) => {
		this.setState({ templateImg });
	};

	getProfilePicture = () => {
		try {
			const query = `{user(id:${Number(
				window.localStorage.getItem("id"),
			)}){profile_picture_url, firstname, lastname,stage, enterprise{id}}}`;
			const payload = {
				url: constants.graphql,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...getAuthHeader(),
				},
				data: JSON.stringify({ query }),
			};

			axios(payload).then((response) => {
				if ([200, 201].includes(response.status)) {
					const data = response.data.data.user;
					this.setState({ profile_picture_url: data?.profile_picture_url });
					this.setState({ full_name: `${data?.firstname} ${data?.lastname}` });
				}
			});
		} catch (error) {
			console.error(error);
		}
	};

	getAllNotifications = async () => {
		try {
			const payload = {
				url: constants.notificationDetails,
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					...getAuthHeader(),
				},
			};
			const response = await axios(payload);
			if ([200, 201].includes(response.status)) {
				const data = response.data.data;
				const row = [];

				for (const [index, key] of data.entries()) {
					if (key) {
						if (key.created_at) {
							row.push({
								id: index + 1,
								key: key.id,
								name: key.name,
								type: key.type,
								date: key.created_at,
								title: key.title,
								text: key.sub_text,
								status: key.status,
								acknowledged:
									key.acknowledged === null ? false : key.acknowledged,
							});
						}
					}
				}
				row.sort((a, b) => (a.date > b.date ? -1 : a.date < b.date ? 1 : 0));

				this.setState({ notifications: row });
				return row;
			}
		} catch (error) {
			console.error(error);
		}
	};

	getUserDetail = (data) => {
		this.setState({ user_data: data });
	};

	hide_popup = () => {
		this.setState({ beefree_popup: false });
	};

	getContactData = (data) => {
		this.setState({
			contact_upload: {
				...this.state.contact_upload,
				preview_row: data.preview_row,
				preview_cols: data.preview_cols,
			},
		});
	};

	clear_state = () => {
		this.setState({ ...iniState });
	};

	fbAudienceUserAttibuteFilters = (filters) => {
		this.setState({
			listOutFbUserFilters: filters,
		});
	};

	fbEditRemoveFromInsights = async (actionType, category, key, index) => {
		const data = {};
		if (actionType && index > -1) {
			data.actionType = actionType;
			data.category = category;
			data.key = key;
			data.index = index;
		}

		localStorage.setItem("actionFromInsigt", JSON.stringify(data));
		this.setState({ fbUserFiterInsightActionData: data });
	};

	fbEditRemoveFromInsightsInEx = async (
		actionType,
		filters,
		index,
		rootIndex,
	) => {
		const data = {};
		if (actionType && index > -1) {
			data.actionType = actionType;
			data.data = filters;
			data.index = index;
			data.rootIndex = rootIndex;
		}

		localStorage.setItem("actionFromInsightInEx", JSON.stringify(data));
		this.setState({ fbUserFiterInsightActionDataInEx: data });
	};

	forAutosegmentTabQuerySave = async (data) => {
		this.setState({ rootFiltersWithContact: data });
	};

	forFactorealTabQuerySave = async (data) => {
		this.setState({ rootFiltersWithContact: data });
	};

	resetListOutFbUserFilters = async () => {
		this.setState({
			listOutFbUserFilters: [],
		});
	};

	storeClonedLA_id = async (id) => {
		this.setState({ clonedLaId: id });
	};

	editRemoveCustomAudience = async (actionType, params) => {
		const d = { actionType, params };
		localStorage.setItem("actionFBCustom", JSON.stringify(d));
		this.setState({ fbCustomAction: d });
	};

	setUserPlan = (userPlan) => this.setState({ userPlan });

	convertToKMFormat = (number) => {
		if (number > 9999 && number < 1000000) {
			return `${(number / 1000).toFixed(2)}k`;
		}
		if (number >= 1000000) {
			return `${(number / 1000000).toFixed(2)}M`;
		}
		return number;
	};

	setDoubleOptinEnabled = (value) => {
		this.setState({ double_optin_enabled: value });
	};

	render() {
		return (
			<Context.Provider
				value={{
					userPlan: this.state.userPlan,
					setUserPlan: this.setUserPlan,
					role: this.state.role,
					callBeeFree: this.callBeeFree,
					contact_upload_count: this.state.contact_upload_count,
					savedTemplate: this.state.savedTemplate,
					campaignFormData: this.state.campaignFormData,
					manageCampaignData: this.manageCampaignData,
					templateNameChange: this.templateNameChange,
					selectedoptionsave: this.selectedoptionsave,
					templatenamesave: this.templatenamesave,
					saveAsTemplate: this.saveAsTemplate,
					save: this.save,
					selectFromLibrary: this.selectFromLibrary,
					templateNameExist: this.templateNameExist,
					fetch_list_industryList: this.fetch_list_industryList,
					handleUploadedFiles: this.handleUploadedFiles,
					exportHtmlForSaveAsTemplate: this.exportHtmlForSaveAsTemplate,
					variantTestingSaveAsTemplate: this.variantTestingSaveAsTemplate,
					exportHtmlForSave: this.exportHtmlForSave,
					uploadFiles: this.uploadFiles,
					contextState: this.state,
					getRandomProducts: this.getRandomProducts,
					enterprisenamesave: this.enterprisenamesave,
					templatenames: this.state.templatenames,
					enterprisename: this.state.enterprisename,
					selectedoption: this.state.selectedoption,
					templateName: this.state.templateName,
					callToFectchContactColumnData: this.callToFectchContactColumnData,
					templateImg: this.state.templateImg,
					createTemplateImg: this.createTemplateImg,
					dataMigration: this.state.dataMigration,
					campagincreation: this.state.campagincreation,
					campagincreationfunc: this.campagincreation,
					setMetadata: this.setMetadata,
					clearCampaignDatafunc: this.clearCampaignData,
					populateCampaignData: this.populateCampaignData,
					senderEmailAndFun: this.senderEmailAndFun,
					socialAdCreationFunc: this.socialAdCreation,
					socialAdCreation: this.state.socialAdCreation,
					smscampaignFunc: this.smscampaign,
					smscampaign: this.state.smscampaign,
					clearSocialAdDatafunc: this.clearSocialAdData,
					clearsmscampaignfunc: this.clearsmsdata,
					journeyTemplatesFunc: this.journeyTemplates,
					journeyTemplates: this.state.journeyTemplates,
					clearjourneyTemplatesFunc: this.clearjourneyTemplates,
					total_balance: this.state.wallet_data.total_balance,
					customertype: this.state.customertype,
					wallet_data: this.state.wallet_data,
					getTotalBalanceFunc: this.getTotalBalance,
					getWalletInfoFunc: this.getWalletInfo,
					getenterpriseFunc: this.getenterprise,
					getCampaignsCount: this.getCampaignsCount,
					getCampaignsData: this.getCampaignsData,
					reloadCampaignsData: this.reloadCampaignsData,
					handleCampaignTabChange: this.handleCampaignTabChange,
					handleTemplateManagerTabChange: this.handleTemplateManagerTabChange,
					showLandingPage: this.showLandingPage,
					handleCampaignSearch: this.handleCampaignSearch,
					handleCampaignPageChange: this.handleCampaignPageChange,
					handleDateFilter: this.handleDateFilter,
					handleAdvancedFilters: this.handleAdvancedFilters,
					deleteCampaign: this.deleteCampaign,
					forceCampaignApiCall: this.forceCampaignApiCall,
					cleaerTotalBalance: this.cleaerTotalBalance,
					getProfilePictureFunc: this.getProfilePicture,
					resetGlobalContextFunc: this.resetGlobalContext,
					getModeratorInfoFunc: this.getModeratorInfo,
					getUserRolesInfoFunc: this.getUserRolesInfo,
					profile_picture_url: this.state.profile_picture_url,
					full_name: this.state.full_name,
					getAllNotificationsFunc: this.getAllNotifications,
					notifications: this.state.notifications,
					facebook_access_token: this.state.facebook_access_token,
					setFbTokenFunc: this.setFbToken,
					getUserDetailFunc: this.getUserDetail,
					user_data: this.state.user_data,
					beefree_args: this.state.beefree_args,
					beefree_reject: this.state.beefree_reject,
					beefree_resolve: this.state.beefree_resolve,
					beefree_popup: this.state.beefree_popup,
					hide_popup: this.hide_popup,
					updateCustomRows: this.updateCustomRows,
					getContactData: this.getContactData,
					contact_upload: this.state.contact_upload,
					clear_state: this.clear_state,
					fbAudienceUserAttibuteFilters: this.fbAudienceUserAttibuteFilters,
					listOutFbUserFilters: this.state.listOutFbUserFilters,
					fbEditRemoveFromInsights: this.fbEditRemoveFromInsights,
					fbUserFiterInsightActionData: this.state.fbUserFiterInsightActionData,
					fbEditRemoveFromInsightsInEx: this.fbEditRemoveFromInsightsInEx,
					fbUserFiterInsightActionDataInEx:
						this.state.fbUserFiterInsightActionDataInEx,
					forFactorealTabQuerySave: this.forFactorealTabQuerySave,
					rootFiltersWithContact: this.state.rootFiltersWithContact,
					resetListOutFbUserFilters: this.resetListOutFbUserFilters,
					editRemoveCustomAudience: this.editRemoveCustomAudience,
					fbCustomAction: this.state.fbCustomAction,
					setDefaultFolder: this.setDefaultFolder,
					clonedLaId: this.clonedLaId,
					storeClonedLA_id: this.storeClonedLA_id,
					storeSocialAdLocFunc: this.storeSocialAdLoc,
					socialAdAudience: this.state.socialAdAudience,
					setSocialAdAudience: this.setSocialAdAudience,
					selectedUserLocation: this.state.selectedUserLocation,
					convertToKMFormat: this.convertToKMFormat,
					bot_provider: this.state.bot_provider,
					double_optin_enabled: this.state.double_optin_enabled,
					setDoubleOptinEnabled: this.setDoubleOptinEnabled,
				}}
			>
				{this.state.is_context_ready ? this.props.children : ""}
			</Context.Provider>
		);
	}
}
